import {useQuery} from '@tanstack/react-query';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {apiClient} from '@common/http/query-client';
import {useParams} from 'react-router-dom';
import { MarketRateDate } from '@app_modules/market-rates/market-rate-date';

const Endpoint = () => `market-rates-date`;

export interface FetchDataResponse extends BackendResponse {
  //  market_rate_date: MarketRateDate[];
  pagination: any;
}

export function useMarketRateDate() {
  return useQuery({
    queryKey: [Endpoint()],
    queryFn: () => fetchMarketRateDate(),
  });
}

function fetchMarketRateDate(): Promise<FetchDataResponse> {
  
  return apiClient.get(Endpoint()).then(response => response.data);
}
